import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'phoneStringToObject'
})
export class PhoneStringToObjectPipe implements PipeTransform {

  transform(value: unknown, ...args: unknown[]): unknown {
    return null;
  }

}
